import { TextField } from "@mui/material";
import { useField } from "formik";

export default function FormikTextField({ label, helperText, ...props }) {
  const [field, meta] = useField(props);
  const tieneError = Boolean(meta.touched && meta.error);
  return (
    <TextField
      label={label}
      {...field}
      {...props}
      error={tieneError}
      // El mensaje de validación de Formik manda cuando hay error; si no,
      // se respeta el helperText estático que haya mandado el consumidor
      // (por ejemplo, avisar que un filtro todavía no responde del lado
      // del proveedor).
      helperText={tieneError ? meta.error : helperText}
      fullWidth
      margin="normal"
    />
  );
}
